import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const proyectoService = {
  generarProyecto,
  getAll,
  getAllByFilter,
  verOtById,
  getResumenHitos,
  getResumenContadores,
}

async function getResumenHitos(idArea, anio) {
  return await ApiBudgety.get('Proyecto/GetAllResumenHitos/' + idArea + '/' + anio)
}

async function getResumenContadores(idArea, anio) {
  return await ApiBudgety.get('Proyecto/GetResumenContadores/' + idArea + '/' + anio)
}

async function generarProyecto(idTrato, proyecto, idUsuario) {
  return await ApiBudgety.post('Proyecto/GenerarProyectoByIdTrato/' + idTrato + '/' + idUsuario, proyecto, {
    headers: {
      ACCION: MenusSistema.proyecto_trato.accesos.generar_proyecto,
      MENU: MenusSistema.proyecto_trato.id,
    },
  })
}

async function getAll() {
  return await ApiBudgety.get('Proyecto/GetAll/')
}

async function getAllByFilter(body) {
  return await ApiBudgety.post('Proyecto/GetAllFilter/', body)
}

async function verOtById(id) {
  return await ApiBudgety.get('Proyecto/VerPdfOtById/' + id, {
    responseType: 'blob', // Indica a Axios que la respuesta será un blob
  })
}
